<style scoped lang="less">
</style>

<template>
    <el-dialog fullscreen :visible.sync="show" title="添加/修改" :close-on-press-escape="false">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="图标">
                <el-input v-model="model.cover"></el-input>
            </el-form-item>
            <el-form-item label="标题">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="跳转类型">
                <el-radio-group v-model="model.toType">
                    <el-radio-button label="商品"></el-radio-button>
                    <el-radio-button label="长图"></el-radio-button>
                    <el-radio-button label="商品列表"></el-radio-button>
                    <el-radio-button label="无跳转"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="商品" v-if="model.toType == '商品'">
                <div class="line-container">
                    <el-input v-model="toGood" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('toGood')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('toGood')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="跳转标题" v-if="model.toType == '长图' || model.toType == '商品列表'">
                <el-input v-model="model.toTitle"></el-input>
            </el-form-item>
            <el-form-item label="跳转长图地址" v-if="model.toType == '长图'">
                <el-input v-model="model.toImageUrl"></el-input>
            </el-form-item>
            <el-form-item label="商品列表" v-if="model.toType == '商品列表'">
                <el-radio-group v-model="model.toGoodList">
                    <el-radio-button label="精选"></el-radio-button>
                    <el-radio-button label="城投债"></el-radio-button>
                    <el-radio-button label="信托"></el-radio-button>
                    <el-radio-button label="在售"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="model.remarks"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false" plain>取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";

import { loginState } from "../../util/login";
import { selectGood } from "../../util/event.js";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
        };
    },
    computed: {
        toGood() {
            if (this.model.toGood) {
                return (
                    this.model.toGood.category +
                    "-" +
                    this.model.toGood.title +
                    "-" +
                    this.model.toGood.expectRate +
                    "-" +
                    this.model.toGood.startAmount
                );
            } else {
                return "";
            }
        },
    },
    created() {},
    mounted() {},
    methods: {
        async chooseItem(key) {
            if (key == "toGood") {
                let item = await selectGood();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                ...item,
                type: "图标",
            });
        },
        async save() {
            this.loadingSave = true;
            await HttpClient.put("/restful", {
                model: "Banner",
                cond: this.model._id,
                updates: this.model,
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

        